import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function IncompleteCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"incomplete_circle"}/>
}
